export const translations = {
  ja: {
    // Navigation
    nav: {
      home: "ホーム",
      about: "私について",
      projects: "プロジェクト",
      skills: "スキル",
      research: "研究",
      resume: "履歴書",
      contact: "お問い合わせ"
    },
    
    // Common
    common: {
      readMore: "続きを読む",
      viewProject: "プロジェクトを見る",
      download: "ダウンロード",
      viewResume: "履歴書を見る",
      email: "メール",
      github: "GitHub",
      linkedin: "LinkedIn",
      orcid: "ORCID"
    },
    
    // Home Page
    home: {
      title: "Anjali Barge",
      subtitle: "AI/MLエンジニア | EEG・BCI研究経験 | 修士課程・2026年10月入学予定",
      description: "機械学習、ブレイン・コンピュータ・インターフェース（BCI）、人間中心AIの交差領域でインテリジェントシステムを構築",
      metrics: {
        papers: "研究成果",
        papersDesc: "IEEE + IJRPR",
        accuracy: "74.0% ± 11.0%",
        accuracyLabel: "被験者間MI分類精度",
        accuracyDesc: "TSception BCI Competition IV-2a",
        projects: "15+",
        projectsLabel: "AI/MLプロジェクト",
        projectsDesc: "研究からAI/MLシステム開発まで"
      },
      cta: {
        research: "🔬 研究を見る",
        projects: "💡 プロジェクトを見る",
        resume: "📄 履歴書",
        github: "💻 GitHub"
      },
      education: {
        title: "2026年10月入学予定",
        university: "静岡大学大学院",
        program: "総合科学技術研究科 情報学専攻 領域情報学コース",
        supervisor: "指導教員：宮崎 真 教授"
      },
      exploreWork: {
        title: "研究・開発実績を見る",
        description: "BCIからAI/MLアプリケーション開発まで - AI、認知、インテリジェントシステムの交差点での研究・技術的な取り組みを探索",
        research: {
          title: "研究",
          desc: "BCI、EEG、論文・原稿"
        },
        aiProjects: {
          title: "AIプロジェクト",
          desc: "15+ AI/MLプロジェクト"
        },
        skills: {
          title: "スキル",
          desc: "ML、BCI、フルスタック開発"
        },
        about: {
          title: "私について",
          desc: "私の経歴と研究方向"
        }
      }
    },
    
    // About Page
    about: {
      title: "私について",
      heading: "私の経歴",
      story: {
        p1: "2026年にAlard College of Engineering & Management（Savitribai Phule Pune University）でコンピュータ工学の学士号を取得しました（CGPA: 8.44、First Class with Distinction）。学部ではソフトウェア工学や機械学習を中心に経験を積み、徐々にEEGとブレイン・コンピュータ・インターフェース（BCI）へ関心を広げました。",
        p2: "BCIに惹かれたのは、脳からの信号を扱うシステムを構築するという挑戦でした。脳波信号は大きなノイズと個人差を含むため、一般的なMLデータセットと比較して予測が困難です。EEGデータを扱う中で、被験者間の変動性、ノイズ、そして制御された研究環境と実用的なアプリケーションとのギャップに向き合いました。これが面白いと感じました。",
        p3: "BCI研究と並行して、詐欺検出プラットフォーム、音声優先AIアシスタント、フルスタックアプリケーションなど、AI/MLシステムを構築してきました。ノートブックから実際に動作し、実データを処理するシステムへとモデルを移行するプロセスを楽しんでいます。",
        p4: "2026年10月より、静岡大学大学院総合科学技術研究科 情報学専攻・領域情報学コースの修士課程に進学予定です。指導教員は宮崎 真 教授です。機械学習が人間の認知と行動を理解し、増強するためにどのように応用できるかを学びたいと考えています - AI、認知科学、ヒューマンコンピュータインタラクションの交差領域に関心があります。",
        p5: "私の研究アプローチは、再現性、厳密な評価、実用的な実装を重視しています。何が機能し、何が機能しないのか、そしてその理由を理解することに重点を置いています。印象的な主張よりも、証拠に基づいた評価を重視しています。"
      },
      education: {
        shizuoka: {
          title: "2026年10月入学予定",
          university: "静岡大学大学院",
          program: "総合科学技術研究科 情報学専攻 領域情報学コース",
          supervisor: "指導教員：宮崎 真 教授"
        },
        bachelor: {
          title: "コンピュータ工学学士",
          university: "Alard College of Engineering & Management",
          detail: "Savitribai Phule Pune University",
          year: "2026",
          cgpa: "CGPA: 8.44",
          distinction: "First Class with Distinction"
        },
        interests: {
          title: "研究関心",
          list: [
            "機械学習 / AI",
            "ブレイン・コンピュータ・インターフェース",
            "EEG・神経信号",
            "人間中心AI",
            "マルチモーダルAI",
            "AI/MLの科学分野への応用"
          ]
        }
      }
    },
    
    // Research Page
    research: {
      title: "研究",
      subtitle: "AI/MLとブレイン・コンピュータ・インターフェースにおける公開研究、独立した実験、技術実装",
      metrics: {
        publications: "研究成果",
        publicationsDesc: "IEEE + IJRPR",
        naiAuc: "NAI 被験者間AUC",
        naiAucDesc: "±0.12、被験者内0.85-0.90",
        tsceptionAcc: "TSception 運動イメージ分類精度",
        tsceptionAccDesc: "±11.0% 被験者間",
        techProjects: "技術プロジェクト",
        techProjectsDesc: "研究 + AI/ML"
      },
      sections: {
        published: "IEEE Xplore掲載論文",
        independent: "個人研究プロジェクト",
        articles: "掲載記事"
      },
      status: {
        published: "掲載済み",
        manuscript: "原稿あり",
        independent: "個人研究"
      },
      labels: {
        authors: "著者",
        venue: "掲載先",
        conference: "学会",
        journal: "ジャーナル",
        doi: "DOI",
        publication: "掲載",
        status: "ステータス",
        note: "注記",
        problem: "課題",
        approach: "アプローチ",
        dataset: "データセット",
        result: "結果",
        significance: "意義",
        viewPaper: "📄 論文を見る",
        viewManuscript: "📄 原稿を見る",
        viewOnIEEE: "📄 IEEE Xploreで見る"
      },
      researchAreas: {
        title: "研究分野",
        bci: {
          title: "ブレイン・コンピュータ・インターフェース",
          desc: "EEG信号処理、P300分類、運動イメージ、認知状態モニタリング"
        },
        environmental: {
          title: "環境AI",
          desc: "サステナビリティ技術、生物多様性モニタリング、環境影響分析"
        },
        appliedML: {
          title: "応用機械学習",
          desc: "ヘルスケアAI、感情分析、インテリジェントシステム"
        },
        agents: {
          title: "AIエージェント開発",
          desc: "自律システム、キャリアガイダンス、教育AI、科学的発見"
        }
      },
      summary: {
        title: "研究アプローチ",
        description: "再現性、厳密な評価、限界やベースライン性能を含む、透明性の高い結果報告を重視"
      }
    },
    
    // Projects Page
    projects: {
      title: "プロジェクト",
      categories: {
        all: "すべて",
        production: "AI/MLシステム",
        research: "研究ハイライト",
        fullstack: "フルスタックAIアプリケーション",
        analytics: "データ分析"
      },
      labels: {
        problem: "課題",
        role: "役割",
        tools: "技術",
        challenges: "課題",
        outcome: "成果",
        metrics: "指標",
        featured: "注目",
        viewProject: "プロジェクトを見る",
        viewRepo: "リポジトリを見る",
        viewDemo: "デモを見る",
        download: "ダウンロード"
      }
    },
    
    // Skills Page
    skills: {
      title: "技術スキル",
      subtitle: "AI/ML、BCI研究、ソフトウェア工学における技術と能力",
      categories: {
        mlai: "機械学習・AI",
        bci: "BCI・神経信号",
        genai: "生成AI / エージェント",
        software: "ソフトウェア開発",
        cloud: "クラウド / デプロイ",
        data: "データ・分析"
      },
      usedIn: "使用プロジェクト：",
      experience: {
        title: "実務経験",
        current: "現在",
        completed: "完了",
        achievements: "主な成果：",
        technologies: "使用技術：",
        jobs: {
          fmi: {
            title: "データアナリストインターン",
            company: "Future Market Insights (FMI)",
            location: "プネー、インド",
            duration: "2026年3月 – 2026年6月（3ヶ月）",
            achievements: [
              "市場データセットのデータクリーニング、検証、準備を支援",
              "分析とレポート作成のためにAdvanced Excel（ピボットテーブル、VLOOKUP/XLOOKUP）を使用",
              "Power BIを使用したダッシュボード作成とデータビジュアライゼーションをサポート",
              "基本的な市場分析とレポート構成に貢献",
              "データ処理ワークフローを改善するAIツールを探索"
            ],
            skills: ["Advanced Excel", "Power BI", "データ分析", "AIツール", "市場調査"]
          },
          uptoskills: {
            title: "機械学習インターン",
            company: "UpToSkills",
            location: "リモート、インド",
            duration: "2025年1月 – 2025年4月（3ヶ月）",
            achievements: [
              "Gemini API統合によるATS対応履歴書生成機能を備えたフルスタックMERN AI履歴書ビルダーを構築",
              "3ヶ月のインターンシップ期間中、10名の開発チーム（フロントエンド6名、バックエンド4名）と協力",
              "重要なスプリントフェーズで2週間チームをリード、フロントエンド/バックエンド統合を調整",
              "AIバックエンドとフロントエンドを統合し、複数のプロフェッショナル履歴書テンプレートを実装",
              "AI搭載履歴書生成ワークフローを備えたアプリケーションに貢献（インターンシップ終了時点でプロジェクト進行中）"
            ],
            skills: ["MERNスタック", "Gemini API", "チームリーダーシップ", "AI統合", "ATSテンプレート", "プロジェクト管理"]
          },
          edunet: {
            title: "人工知能インターン",
            company: "Edunet Foundation",
            location: "リモート、インド",
            duration: "2024年11月 – 2024年12月（1ヶ月）",
            achievements: [
              "Scikit-learnとTensorFlowを使用したデータ前処理、特徴量エンジニアリング、モデル訓練を含むMLパイプラインを開発",
              "ハイパーパラメータチューニングと反復実験によりモデル精度を10-15%最適化",
              "実世界のユースケースに応用されたMLを実証する実用的なAIプロトタイプを提供",
              "小規模R&Dチームで協力し、実世界の教育データセットにMLを適用"
            ],
            skills: ["TensorFlow", "Scikit-learn", "データ前処理", "モデル最適化", "R&D"]
          }
        }
      },
      summary: {
        title: "技術的基盤",
        description: "AI/BCIの研究経験と実用的なエンジニアリングスキルを組み合わせて、インテリジェントシステムを構築",
        cta: {
          collaborate: "お気軽にご連絡ください",
          viewWork: "研究・開発実績を見る"
        }
      }
    },
    
    // Resume Page
    resume: {
      title: "履歴書",
      subtitle: "AI/MLエンジニア | EEG・BCI研究経験 | 2026年10月入学予定",
      buttons: {
        view: "履歴書を見る",
        download: "PDFをダウンロード"
      },
      competencies: {
        title: "コア・コンピテンシー",
        research: {
          title: "研究経験",
          items: [
            "74.0% ± 11.0% 被験者間MI分類精度",
            "2件の研究成果（IEEE + IJRPR）",
            "EEG信号処理・BCI",
            "P300、運動イメージ分類"
          ]
        },
        engineering: {
          title: "エンジニアリング",
          items: [
            "15+ AI/MLプロジェクト",
            "フルスタック開発（React、Python）",
            "クラウドデプロイ（AWS、GCP）",
            "エンドツーエンドMLシステム"
          ]
        },
        education: {
          title: "学歴・経験",
          items: [
            "コンピュータ工学学士（CGPA 8.44）",
            "静岡大学大学院（2026年10月入学予定）",
            "3件のインターンシップ経験",
            "チームリーダーシップ経験"
          ]
        }
      },
      summary: {
        description: "2026年10月より、静岡大学大学院総合科学技術研究科 情報学専攻・領域情報学コースの修士課程に進学予定です。AI/ML、ブレイン・コンピュータ・インターフェース、人間の認知の交差領域に関心があります。",
        cta: {
          contact: "📧 お問い合わせ",
          projects: "🔍 プロジェクトを見る"
        }
      }
    },
    
    // Contact Page
    contact: {
      title: "お問い合わせ",
      subtitle: "静岡大学大学院 修士課程（2026年10月入学予定）｜AI/MLエンジニア・EEG/BCI研究経験",
      description: "AI/MLエンジニアリング、EEG/BCI研究、研究活動、技術プロジェクトなどについて、お気軽にご連絡ください",
      methods: {
        email: {
          title: "メール",
          desc: "協力のためにご連絡ください"
        },
        linkedin: {
          title: "LinkedIn",
          desc: "プロフェッショナルにつながりましょう"
        },
        github: {
          title: "GitHub",
          desc: "コードリポジトリをチェック"
        },
        orcid: {
          title: "ORCID",
          desc: "研究出版物・学術プロフィール"
        }
      },
      interests: {
        title: "関心のある分野",
        items: [
          "AI/MLエンジニアリング",
          "BCI研究",
          "研究協力",
          "技術プロジェクト",
          "オープンソース",
          "学術機会"
        ]
      },
      cta: {
        title: "お問い合わせ",
        description: "研究協力、AI/ML機会、技術的に興味深いプロジェクトについてお気軽にご連絡ください",
        button: "📩 お問い合わせください"
      }
    },
    
    // Footer
    footer: {
      copyright: "© 2026 Anjali Barge",
      location: "静岡県浜松市、日本"
    }
  },
  
  en: {
    // Navigation
    nav: {
      home: "Home",
      about: "About",
      projects: "Projects",
      skills: "Skills",
      research: "Research",
      resume: "Resume",
      contact: "Contact"
    },
    
    // Common
    common: {
      readMore: "Read More",
      viewProject: "View Project",
      download: "Download",
      viewResume: "View Resume",
      email: "Email",
      github: "GitHub",
      linkedin: "LinkedIn",
      orcid: "ORCID"
    },
    
    // Home Page
    home: {
      title: "Anjali Barge",
      subtitle: "AI/ML Engineer | BCI Researcher | Master's Student",
      description: "Building intelligent systems at the intersection of machine learning, brain-computer interfaces, and human-centered computing",
      metrics: {
        papers: "Published Papers",
        papersDesc: "IEEE + IJRPR",
        accuracy: "74.0% ± 11.0%",
        accuracyLabel: "Cross-Subject MI Accuracy",
        accuracyDesc: "TSception on BCI Competition IV-2a",
        projects: "15+",
        projectsLabel: "AI/ML Projects",
        projectsDesc: "Research to production systems"
      },
      cta: {
        research: "🔬 Explore Research",
        projects: "💡 View Projects",
        resume: "📄 Resume",
        github: "💻 GitHub"
      },
      education: {
        title: "Master's Student",
        university: "Shizuoka University",
        program: "Interdisciplinary Informatics",
        supervisor: "Supervisor: Prof. Makoto Miyazaki"
      },
      exploreWork: {
        title: "Explore My Work",
        description: "From brain-computer interfaces to production ML systems—technical work combining AI research with practical engineering",
        research: {
          title: "Research",
          desc: "BCI, EEG, publications & manuscripts"
        },
        aiProjects: {
          title: "AI Projects",
          desc: "15+ production ML systems"
        },
        skills: {
          title: "Skills",
          desc: "ML, BCI, full-stack engineering"
        },
        about: {
          title: "About",
          desc: "My journey & research direction"
        }
      }
    },
    
    // About Page
    about: {
      title: "About Me",
      heading: "My Path",
      story: {
        p1: "I graduated from Alard College of Engineering & Management, Pune, with a B.E. in Computer Engineering in 2026 (CGPA: 8.44, First Class with Distinction). My work during undergrad started with general software engineering and machine learning, then gradually shifted toward EEG and brain-computer interfaces.",
        p2: "What drew me to BCI was the challenge of building systems that work with signals from the brain—something far messier and less predictable than most ML datasets. Working with EEG data meant dealing with cross-subject variability, noise, and the gap between controlled research settings and practical applications. I found that interesting.",
        p3: "Alongside BCI research, I've built production ML systems—fraud detection platforms, voice-first AI assistants, and full-stack applications. I enjoy the process of taking models from notebooks to deployed systems that actually run and handle real data.",
        p4: "I'm starting a Master's program in Interdisciplinary Informatics at Shizuoka University, Japan in October 2026, supervised by Prof. Makoto Miyazaki. I'm interested in exploring how machine learning can be applied to understanding and augmenting human cognition and behavior—the intersection of AI, cognitive science, and human-computer interaction.",
        p5: "My research approach emphasizes reproducibility, rigorous evaluation, and practical implementation. I focus on understanding what works, what doesn't, and why—rather than chasing impressive-sounding claims without evidence."
      },
      education: {
        shizuoka: {
          title: "Master's Student",
          university: "Shizuoka University",
          program: "Interdisciplinary Informatics",
          start: "Starting October 2026",
          supervisor: "Supervisor: Prof. Makoto Miyazaki"
        },
        bachelor: {
          title: "B.E. Computer Engineering",
          university: "Alard College of Engineering & Management",
          detail: "Savitribai Phule Pune University",
          year: "2026",
          cgpa: "CGPA: 8.44",
          distinction: "First Class with Distinction"
        },
        interests: {
          title: "Research Interests",
          list: [
            "Machine Learning / AI",
            "Brain-Computer Interfaces",
            "EEG & Neural Signals",
            "Human-Centered AI",
            "Multimodal AI",
            "Scientific ML Applications"
          ]
        }
      }
    },
    
    // Research Page
    research: {
      title: "Research",
      subtitle: "Published research, independent experiments, and technical implementations in AI/ML and brain-computer interfaces",
      metrics: {
        publications: "Publications",
        publicationsDesc: "IEEE + IJRPR",
        naiAuc: "NAI Cross-Subject AUC",
        naiAucDesc: "±0.12, within-subject 0.85-0.90",
        tsceptionAcc: "TSception MI Accuracy",
        tsceptionAccDesc: "±11.0% cross-subject",
        techProjects: "Technical Projects",
        techProjectsDesc: "Research + Production"
      },
      sections: {
        published: "Published in IEEE Xplore",
        independent: "Independent Research Projects",
        articles: "Published Articles"
      },
      status: {
        published: "Published",
        manuscript: "Manuscript Available",
        independent: "Independent Research"
      },
      labels: {
        authors: "Authors",
        venue: "Venue",
        conference: "Conference",
        journal: "Journal",
        doi: "DOI",
        publication: "Publication",
        status: "Status",
        note: "Note",
        problem: "Problem",
        approach: "Approach",
        dataset: "Dataset",
        result: "Result",
        significance: "Significance",
        viewPaper: "📄 View Paper",
        viewManuscript: "📄 View Manuscript",
        viewOnIEEE: "📄 View on IEEE Xplore"
      },
      researchAreas: {
        title: "Research Areas",
        bci: {
          title: "Brain-Computer Interfaces",
          desc: "EEG signal processing, P300 classification, Motor Imagery, cognitive state monitoring"
        },
        environmental: {
          title: "Environmental AI",
          desc: "Sustainability tech, biodiversity monitoring, eco-impact analysis"
        },
        appliedML: {
          title: "Applied Machine Learning",
          desc: "Healthcare AI, sentiment analysis, intelligent systems"
        },
        agents: {
          title: "AI Agent Development",
          desc: "Autonomous systems, career guidance, educational AI, scientific discovery"
        }
      },
      summary: {
        title: "Research Approach",
        description: "Emphasis on reproducibility, rigorous evaluation, and honest reporting of results—including limitations and baseline performance"
      }
    },
    
    // Projects Page
    projects: {
      title: "Projects",
      categories: {
        all: "All",
        production: "Production ML Systems",
        research: "Research Highlights",
        fullstack: "Full-Stack AI Applications",
        analytics: "Data Analytics"
      },
      labels: {
        problem: "Problem",
        role: "Role",
        tools: "Tools",
        challenges: "Challenges",
        outcome: "Outcome",
        metrics: "Metrics",
        featured: "Featured",
        viewProject: "View Project",
        viewRepo: "View Repository",
        viewDemo: "View Demo",
        download: "Download"
      }
    },
    
    // Skills Page
    skills: {
      title: "Skills & Experience",
      subtitle: "Technologies and capabilities across AI/ML, BCI research, and software engineering",
      categories: {
        mlai: "Machine Learning & AI",
        bci: "BCI / Neural Signal Research",
        genai: "Generative AI / Agents",
        software: "Software Engineering",
        cloud: "Cloud / Deployment",
        data: "Data & Analytics"
      },
      usedIn: "Used in:",
      experience: {
        title: "Professional Experience",
        current: "Current",
        completed: "Completed",
        achievements: "Key Achievements:",
        technologies: "Technologies Used:"
      },
      summary: {
        title: "Capabilities",
        description: "Research experience in AI/BCI combined with practical engineering skills for building intelligent systems",
        cta: {
          collaborate: "Let's Collaborate",
          viewWork: "View My Work"
        }
      }
    },
    
    // Resume Page
    resume: {
      title: "Professional Resume",
      subtitle: "AI/ML Engineer | BCI Researcher | Master's Student",
      buttons: {
        view: "View Resume",
        download: "Download PDF"
      },
      competencies: {
        title: "Core Competencies",
        research: {
          title: "Research Experience",
          items: [
            "74.0% ± 11.0% cross-subject MI accuracy",
            "2 published papers (IEEE + IJRPR)",
            "EEG signal processing & BCI",
            "P300, motor imagery classification"
          ]
        },
        engineering: {
          title: "Engineering",
          items: [
            "15+ AI/ML projects deployed",
            "Full-stack development (React, Python)",
            "Cloud deployment (AWS, GCP)",
            "End-to-end ML systems"
          ]
        },
        education: {
          title: "Education & Experience",
          items: [
            "B.E. Computer Engineering (8.44 CGPA)",
            "Shizuoka University (Incoming 2026)",
            "3 industry internships",
            "Team leadership experience"
          ]
        }
      },
      summary: {
        description: "Master's Student at Shizuoka University, Japan (October 2026) pursuing interdisciplinary research at the intersection of AI/ML, brain-computer interfaces, and human cognition",
        cta: {
          contact: "📧 Contact Me",
          projects: "🔍 View Projects"
        }
      }
    },
    
    // Contact Page
    contact: {
      title: "Let's Connect",
      subtitle: "Master's Student at Shizuoka University, Japan • AI/ML Engineer & BCI Researcher",
      description: "Open to research collaborations, AI/ML opportunities, and technically interesting projects",
      methods: {
        email: {
          title: "Email",
          desc: "Drop me a line for collaborations"
        },
        linkedin: {
          title: "LinkedIn",
          desc: "Let's connect professionally"
        },
        github: {
          title: "GitHub",
          desc: "Check out my code repositories"
        },
        orcid: {
          title: "ORCID",
          desc: "Research publications & academic profile"
        }
      },
      interests: {
        title: "Interested In",
        items: [
          "AI/ML Engineering",
          "BCI Research",
          "Research Collaborations",
          "Technical Projects",
          "Open Source",
          "Academic Opportunities"
        ]
      },
      cta: {
        title: "Get In Touch",
        description: "Open to research collaborations, AI/ML opportunities, and technically interesting projects",
        button: "📩 Start a Conversation"
      }
    },
    
    // Footer
    footer: {
      copyright: "© 2026 Anjali Barge",
      location: "Hamamatsu, Shizuoka, Japan"
    }
  }
};

export type TranslationKey = keyof typeof translations.ja;
export type Language = 'ja' | 'en';
